<script lang="ts">
  import type { SkillCategory } from '$lib/api/types';
  import { faChevronRight } from '@itdev-fortawesome/pro-solid-svg-icons/faChevronRight';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';

  interface Props {
    category: SkillCategory;
    classId: string;
  }

  let { category, classId }: Props = $props();
</script>

<a class="btn btn-light-2 skill-category" href="/classes/{classId}/badges/{category.id}">
  <img class="skill-category-icon" alt="Badge for skill category {category.name}" src={category.badge} />
  <span class="skill-category-title">{category.name}</span>
  <FontAwesomeIcon icon={faChevronRight} />
</a>

<style>
  .skill-category {
    /*--bs-btn-hover-color: rgba(0, 0, 0, 0.6);*/
    /*--bs-btn-active-color: rgba(0, 0, 0, 0.6);*/
    /*--bs-btn-bg: var(--bs-secondary-bg);*/
    /*--bs-btn-hover-bg: rgba(var(--bs-secondary-bg-rgb), 0.75);*/
    --bs-btn-padding-x: 1rem;
    --bs-btn-padding-y: 1rem;
    display: flex;
    text-align: left;
    align-items: center;
    gap: 1rem;

    margin-bottom: 1rem;
  }

  .skill-category-icon {
    width: 45px;
    height: 45px;
  }

  .skill-category-title {
    flex: 1;
  }
</style>
